/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants =
  reactQueryMutationAdapter(
    postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsCacheKeys,
    (
      props: PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsProps
    ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_components/${props.component}/variants`,
        "POST",
        {
          creative: props.creative,
          base_creative_campaign_ids: props.base_creative_campaign_ids,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
